import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  header: {
    title: {
      de: 'Unsere Projekte',
      en: 'References'
    },
    description: {
      de: 'Entdecke, wie wir Unternehmen durch maßgeschneiderte digitale Lösungen zum Erfolg verhelfen.',
      en: 'Discover our success stories and customer projects.'
    }
  },
  search: {
    placeholder: {
      de: 'Nach Kunden oder Projekten suchen...',
      en: 'Search for clients or projects...'
    },
    shortcut: {
      de: 'für Suche',
      en: 'for search'
    },
    noResults: {
      de: 'Keine Referenzen für die gewählten Filter gefunden.',
      en: 'No references found for the selected filters.'
    },
    resetFilters: {
      de: 'Bitte wählen Sie andere Filter oder setzen Sie die Filter zurück.',
      en: 'Please choose other filters or reset the filters.'
    }
  },
  logoCarousel: {
    title: {
      de: 'Unsere Kunden',
      en: 'Our Clients'
    },
    description: {
      de: 'Diese Unternehmen arbeiten mit uns zusammen',
      en: 'These companies work with us'
    },
    button: {
      de: 'Zu den Projekten',
      en: 'View Projects'
    }
  }
}); 